import { Page } from '../../../../components/Page/Page';
import { DeputateSubjectsTable } from '../../../../components/Subjects/Tables/DeputateSubjectsTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const DeputateSubjectsSubpage = () => {
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <DeputateSubjectsTable />
    </Page>
  );
};
